__turbopack_context__.v({
  "Footer": "Footer-module__rnk_JG__Footer",
});
